import {
  FETCH_UPLOAD_FOLDER_REQUEST,
  FETCH_UPLOAD_FOLDER_SUCCESS,
  FETCH_UPLOAD_FOLDER_FALUIRE,
} from './uploadFolderTypes'

const initialState = {
  loading: false,
  isFolderUploadedSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_UPLOAD_FOLDER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_UPLOAD_FOLDER_SUCCESS : return {
      ...state,
      isFolderUploadedSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_UPLOAD_FOLDER_FALUIRE : return {
      ...state,
      loading: false,
      isFolderUploadedSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
